module.exports = __webpack_public_path__ + "static/img/logo_reverse.6967e57d.svg";